import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Alert from './Alert.jsx';

export default class AlertSlideDown extends Component {
	static propTypes = {
		renderAlert: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool
		]),
		alertMessage: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		qaSelector: PropTypes.string,
		decoratorClass: PropTypes.string,
		id: PropTypes.string,
		transitionName: PropTypes.string,
		transitionDuration: PropTypes.number,
		transitionLeave: PropTypes.bool,
		alertType: PropTypes.string.isRequired
	};
	static defaultProps = {
		id: 'dnaAlertError',
		qaSelector: 'dnaAlertError',
		transitionDuration: 1200,
		transitionLeave: false,
		transitionName: 'alert-slide-down'
	};
	render() {
		const {
			id,
			alertType,
			alertMessage,
			qaSelector,
			decoratorClass,
			renderAlert,
			transitionName,
			transitionDuration,
			transitionLeave
		} = this.props;

		return (
			<ReactCSSTransitionGroup
				transitionName={transitionName}
				transitionEnterTimeout={transitionDuration}
				transitionLeave={transitionLeave}>
				{ renderAlert &&
					<Alert
						id={id}
						decoratorClass={decoratorClass}
						alertType={alertType}
						alertMessage={alertMessage}
						qaSelector={qaSelector} />
				}
			</ReactCSSTransitionGroup>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-alert/components/alert/AlertSlideDown.jsx